var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-scrollbar__wrap wrap-white padding-20" },
    [
      _c(
        "div",
        { staticClass: "el-scrollbar__view" },
        [
          _c(
            "el-form",
            {
              ref: "inputForm",
              attrs: {
                size: "small",
                inline: true,
                model: _vm.inputForm,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "二维码内容",
                    prop: "encoderContent",
                    rules: [
                      {
                        required: true,
                        message: "内容不能为空",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: { placeholder: "请输入要生成二维码的字符串" },
                    model: {
                      value: _vm.inputForm.encoderContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputForm, "encoderContent", $$v)
                      },
                      expression: "inputForm.encoderContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.doSubmit } },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.imageUrl
            ? _c(
                "div",
                {
                  staticStyle: {
                    "padding-left": "120px",
                    "padding-top": "20px",
                  },
                },
                [
                  _c("el-image", { attrs: { src: _vm.imageUrl } }),
                  _c("p", [_vm._v("请使用微信扫一扫")]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }